// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__tSz-u","checkboxCol":"Table_checkboxCol__19L7z","emailCol":"Table_emailCol__36gdF","actionCol":"Table_actionCol__1BG6G"};